import './Typography.css';
export default {
    "root": "Typography_root__487rx",
    "display-lg": "Typography_display-lg__487rx",
    "display-md": "Typography_display-md__487rx",
    "display-sm": "Typography_display-sm__487rx",
    "heading-xl": "Typography_heading-xl__487rx",
    "heading-lg": "Typography_heading-lg__487rx",
    "heading-md": "Typography_heading-md__487rx",
    "heading-sm": "Typography_heading-sm__487rx",
    "body-lg": "Typography_body-lg__487rx",
    "body-lg-bold": "Typography_body-lg-bold__487rx",
    "body-md": "Typography_body-md__487rx",
    "body-md-bold": "Typography_body-md-bold__487rx",
    "body-sm": "Typography_body-sm__487rx",
    "body-sm-bold": "Typography_body-sm-bold__487rx",
    "body-caption": "Typography_body-caption__487rx",
    "align-match-parent": "Typography_align-match-parent__487rx",
    "align-left": "Typography_align-left__487rx",
    "align-center": "Typography_align-center__487rx",
    "align-right": "Typography_align-right__487rx",
    "align-justify": "Typography_align-justify__487rx",
    "align-start": "Typography_align-start__487rx",
    "align-end": "Typography_align-end__487rx"
};
